import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

var experiments_to_i18n = function(i18n, experiments) {
  let messages = { fr: {}, en: {} };
  for (let i in experiments) {
    try {
      let remote_messages = JSON.parse(experiments[i].locales);
      for (let locale in remote_messages) {
        for (let key in remote_messages[locale]) {
          messages[locale][`${experiments[i].identifier}_${key}`] =
            remote_messages[locale][key];
        }
      }
    } catch (e) {
      console.log(e);
      console.log(experiments);
    }
  }
  let json_messages = loadLocaleMessages();
  for (let locale in json_messages) {
    Object.assign(messages[locale], json_messages[locale]);
  }
  for (let locale in messages) {
    i18n.setLocaleMessage(locale, messages[locale]);
  }
};

export { experiments_to_i18n };
export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "en",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: {}
});
